import AxiosClient from './api'
import END_POINT from './constants'

export function getWeeklyNote(payload) {
  const { id, start, end, sortType, sortBy } = payload
  let param = '?'
  if (sortType) {
    param += `sortType=${sortType}`
  }
  if (sortBy) {
    param += `&sortBy=${sortBy}`
  }
  if (start) {
    param += `&start=${start}`
  }
  if (end) {
    param += `&end=${end}`
  }
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.GET_WEEKLY_NOTE}/${id}${param}`)
      .then((res) => {
        const { rows, timezone } = res.data.result
        const sliceData = rows.slice(0, 2)
        resolve({
          notes: sliceData,
          timezone
        })
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function updateWeeklyNote(payload) {
  const { id, note, portfolioId } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.put(`${END_POINT.WEEKLY_NOTE}/${id}`, {
      note,
      portfolio_id: portfolioId
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function createWeeklyNote(payload) {
  const { note, portfolioId } = payload
  return new Promise((resolve, reject) => {
    AxiosClient.post(`${END_POINT.WEEKLY_NOTE}`, {
      note,
      portfolio_id: portfolioId
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}

export function getOpenFile(payload) {
  return new Promise((resolve, reject) => {
    AxiosClient.get(`${END_POINT.WEEKLY_MANAGEMENT_ID}/${payload.portfolio_id}/note/${payload.id}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err.message)
      })
  })
}
